import React  from 'react'

export function OrderQuestion(props: any) {
    const {options} = props;

    let staticOptions = options.filter((option: { staticOption: any; }) => !option.staticOption);
    staticOptions = staticOptions.sort((a: { queueNo: number; }, b: {
        queueNo: number;
    }) => a.queueNo - b.queueNo);

    function getMatchedOption(trueOptionId: any){
        let returnData = options.find((option: {
            queueNo: any;
            staticOption: boolean;
            id: number
        }) => (option.id === trueOptionId && option.staticOption)) || {}
        return returnData;
    }

    return (
        <div>
            {
                staticOptions?.map((option: any) => {
                    return (
                        <div className={`questionOption ${option.trueOption && 'trueOption'}`}>
                            <p className={"optionQueueNo"}>{option.optionName}</p>
                            <span>{option.title}</span>
                            <label>{getMatchedOption(option.trueOptionId).title}</label>
                        </div>
                    )
                })
            }
        </div>
    )
}
